import { z } from "zod";
import { PaginationRequestSchema, PaginationResponseSchema } from "./pagination";

export const TeamQuerySchema = PaginationRequestSchema.extend({
  name: z.string().optional(),
  code: z.string().optional(),
  countryId: z.string().optional(),
  national: z.coerce.boolean().optional(),
});
export type TeamQueryDTO = z.infer<typeof TeamQuerySchema>;

export const TeamResponseSchema = z.object({
  id: z.string(),
  name: z.string(),
  code: z.string(),
  countryId: z.string().nullable(),
  founded: z.number().nullable(),
  national: z.boolean(),
  logo: z.string().nullable(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
  country: z
    .object({
      id: z.string(),
      name: z.string(),
      flag: z.string().nullable(),
    })
    .nullable()
    .optional(),
});
export type TeamResponseDTO = z.infer<typeof TeamResponseSchema>;

export const TeamsPaginatedResponseSchema = PaginationResponseSchema(
  TeamResponseSchema
);
export type TeamsPaginatedResponseDTO = z.infer<
  typeof TeamsPaginatedResponseSchema
>;

export const CreateTeamRequestSchema = z.object({
  name: z.string().min(1, "El nombre es requerido"),
  code: z.string().min(1, "El código es requerido"),
  countryId: z.string().optional(),
  founded: z.number().optional(),
  national: z.boolean().optional().default(false),
  logo: z.string().optional(),
});

export const UpdateTeamRequestSchema = CreateTeamRequestSchema.partial();

export type CreateTeamRequestDTO = z.infer<typeof CreateTeamRequestSchema>;
export type UpdateTeamRequestDTO = z.infer<typeof UpdateTeamRequestSchema>;
